import gql from 'graphql-tag';

export const UPDATE_CONVERSATION = gql`
  mutation ($conversationId: Int!, $status: ConversationStatus!, $appointmentId: String!) {
    updateConversation (input: { conversationId: $conversationId, status: $status, appointmentId: $appointmentId }) {
      conversationId
      createdBy
      type
      start
      end
      participants {
        user {
          userId
          type
          profile {
            phoneNumber
            firstName
            lastName
            middleName
            dateOfBirth
            avatar
            timezone
            policyId
            externalId
            isVerified
            isTosAccepted
            isIdEligible
            title
            gender
            changePasswordRequired
          }
        }
        participantType
      }
      status
      statusHistory {
        status
        createdAt
      }
      call {
        callDeadLineTimestamp
        callerName
      }
    }
  }
`;
